var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[(_vm.showConfigurator)?_c('div',{attrs:{"id":"configurator-wrapper"}},[_c('Header'),_vm._v(" "),_c('ContentBlock',{attrs:{"fee":_vm.fee}}),_vm._v(" "),_c('FAQ',{attrs:{"fee":_vm.fee}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d3e6e7a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Lokal.vue
// module id = null
// module chunks = 